import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'auth-screen',
    imports: [CommonModule],
    templateUrl: './spovix-auth-screen.component.html',
    styleUrls: ['./spovix-auth-screen.component.scss']
})
export class SpovixAuthScreenComponent {}
